var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageWrapper',[_c('h1',[_c('Locale',{attrs:{"path":"routes.contact"}})],1),_c('CMSView',{attrs:{"group":"contact_page","include":['body']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }